import {CategoryToAddModel} from "./category-to-add.model";

export class AddOrEditMenuModel {
  public id: string;
  public name: string;
  public description: string;
  public languageId: number;
  public defaultCurrencyId: string;
  public companyId: string;
  public categories: Array<CategoryToAddModel>;
  public categoryIds: Array<string> = new Array<string>();
  public subcategoryIds: Array<string> = new Array<string>();
}
